import type { UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { Store } from './model/Store';

export const useStore = (id?: string): UseQueryResult<Store> =>
    useBffGet(id ? `/stores/${id}` : null, [], [BffQueryKey.STORE, id ?? ''], {
        enabled: !isServer && !!id,
    });
